export const generateHref = (projectId: string, page: string, entity: string) => `/${projectId}/${page}/${entity}`;

export default generateHref;
